import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';

import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { BuyGemsDialog } from 'components/commonCard/BuyGemsDialog';

import type {
  BuyGemsDialogQuery,
  BuyGemsDialogQueryVariables,
} from './__generated__/index.graphql';

const BUY_GEMS_DIALOG_QUERY = gql`
  query BuyGemsDialogQuery {
    market {
      id
      gemsPacks: inGameCurrencyPacks(sport: FOOTBALL, currency: COMMON_GEM) {
        id
        ...BuyGemsDialog_inGameCurrencyPack
      }
    }
  }
  ${BuyGemsDialog.fragments.inGameCurrencyPack}
` as TypedDocumentNode<BuyGemsDialogQuery, BuyGemsDialogQueryVariables>;

export const SearchParamBasedBuyGemsDialog = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const buyGems = searchParams.get('buy_gems');
  const { data } = useQuery(BUY_GEMS_DIALOG_QUERY, {
    skip: !buyGems,
  });
  const { market } = data || {};
  return (
    <BuyGemsDialog
      open={!!buyGems}
      onClose={() => {
        searchParams.delete('buy_gems');
        setSearchParams(searchParams, {
          replace: true,
        });
      }}
      gemsPacks={market?.gemsPacks}
    />
  );
};
